import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Toasts from 'components/Toasts';
import PortalLogin from './PortalLogin';
import ApiGatewayLogin from './ApiGatewayLogin';
import PasswordReset from './PasswordReset';
import Password from './Password';
import { MainContainer } from './components/styledComponents';

function Login({
  dealerId,
  csrfToken,
  defaultScreen,
  mode,
  formAction,
  oauthParams,
  translations,
}) {
  const PORTAL_LOGIN = 'PortalLogin';
  const PASSWORD_RESET = 'PasswordReset';
  const PASSWORD = 'Password';

  const [screen, setScreen] = useState(defaultScreen);

  return (
    <MainContainer>
      <Toasts />

      {screen === PORTAL_LOGIN &&
        (mode === 'apiGateway' ? (
          <ApiGatewayLogin
            csrfToken={csrfToken}
            formAction={formAction}
            oauthParams={oauthParams}
            translations={translations}
            requestPasswordClick={() => setScreen(PASSWORD_RESET)}
          />
        ) : (
          <PortalLogin
            dealerId={dealerId}
            csrfToken={csrfToken}
            translations={translations}
            requestPasswordClick={() => setScreen(PASSWORD_RESET)}
          />
        ))}
      {screen === PASSWORD_RESET && (
        <PasswordReset
          csrfToken={csrfToken}
          translations={translations}
          backLoginClick={() => setScreen(PORTAL_LOGIN)}
        />
      )}
      {screen === PASSWORD && (
        <Password
          csrfToken={csrfToken}
          translations={translations}
          backLoginClick={() => setScreen(PORTAL_LOGIN)}
        />
      )}
    </MainContainer>
  );
}

Login.propTypes = {
  dealerId: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  defaultScreen: PropTypes.string,
  mode: PropTypes.string,
  formAction: PropTypes.string,
  oauthParams: PropTypes.objectOf(PropTypes.string),
  translations: PropTypes.objectOf(PropTypes.string),
};

Login.defaultProps = {
  dealerId: '',
  defaultScreen: 'PortalLogin',
  mode: 'standard',
  formAction: '',
  oauthParams: {},
  translations: {},
};

export default Login;
